<template>
  <div class="fotter">
    <div class="service">
      <div class="w">
        <div class="f_service">
          <ul class="clearfix">
            <li>
              <div class="serImg">
                <img src="../../assets/index/fotter/sheji.png" />
              </div>
              <div class="serInfo">
                <p class="info1">免费设计</p>
                <p class="info2">印刷送设计费</p>
              </div>
            </li>
            <li>
              <div class="serImg">
                <img src="../../assets/index/fotter/wuliu.png" />
              </div>
              <div class="serInfo infoT">
                <p class="info1">全国物流</p>
                <p class="info2">大物物流小物快递</p>
              </div>
            </li>

            <li>
              <div class="serImg">
                <img src="../../assets/index/fotter/dayin.png" />
              </div>
              <div class="serInfo">
                <p class="info1">优质印刷</p>
                <p class="info2">二十多年印刷经验</p>
              </div>
            </li>

            <li>
              <div class="serImg">
                <img src="../../assets/index/fotter/shouhou.png" />
              </div>
              <div class="serInfo">
                <p class="info1">售后无忧</p>
                <p class="info2">订单问题负责到底</p>
              </div>
            </li>

            <li>
              <div class="serImg">
                <img src="../../assets/index/fotter/shengchan.png" />
              </div>
              <div class="serInfo">
                <p class="info1">急速生产</p>
                <p class="info2">最快24小时出货</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="help">
      <div class="w">
        <div class="f_help clearfix">
          <div class="mod_help" v-for="(item,index) in cateNewData" :key="index">
            <h5 class="mod_help_title">{{item.cate_name}}</h5>
            <ul>
              <li v-for="item1 in item.list" :key="item1.id">
                <a href="javascript:void(0);" @click="goNew(item1)">{{item1.title}}</a>
              </li>
            </ul>
          </div>
          <div class="mod_cover">
            <img class="qrcode" />
            <p class="sy_date"></p>
            <h3>{{info.kfmobile}}</h3>
          </div>
        </div>
        <div class="f_copy"><a href="https://beian.miit.gov.cn/"> CopyRight&copy;2020 {{info.beian}}</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: [],
      cateNewData: []
    }
  },
  methods: {
    async queryInfo() {
      const { data: res } = await this.$http.get('/api/index/apidata')
      this.info = res.data
      $('.logo a .sy_logo').attr('src', res.data.logo)
      $('.qrcode').attr('src', res.data.qrcode)
      $('.sy_date').text(res.data.business_hours)
      let sy_info = {
        logo: res.data.logo,
        beian: res.data.beian
      }
      window.sessionStorage.setItem('sy_info', JSON.stringify(sy_info))
    },
    async queryCateNews() {
      const { data: res } = await this.$http.get('api/index/getnewscate')
      if (res.code) {
        this.cateNewData = res.data
      }
    },
    goNew(item) {
      window.sessionStorage.setItem('n', item.title)
      this.$router.push('/newList?id=' + item.id)
    }
  },
  mounted() {
    this.$nextTick(_ => {
      this.queryInfo()
      this.queryCateNews()
    })
  }
}
</script>

<style lang="less" scoped>
.fotter {
  margin-top: 30px;
  height: 368px;
  .service {
    background: #fff;
    .w {
      .f_service {
        height: 102px;
        background: #fff;
        ul {
          display: flex;
          padding: 23px 0;
          li {
            text-align: center;
            float: left;
            flex: 20%;
            .serImg {
              display: inline-block;
              width: 50px;
              height: 50px;
              margin: auto;
            }
            .serInfo {
              display: inline-block;
              width: 150px;
              height: 50px;
              margin: auto;
              transform: translate(7%, 30%);
              .info1 {
                font-size: 18px;
                color: #333;
                text-align: left;
              }
              .info2 {
                font-size: 12px;
                color: #999;
                text-align: left;
              }
            }
            .infoT {
              transform: translate(18%, 30%);
            }
          }
        }
      }
    }
  }
  .help {
    height: 265px;
    background-color: #444444;
    .w {
      .f_help {
        padding-top: 35px;
        .mod_help {
          float: left;
          width: 165px;
          height: 167px;
          border-right: 1px solid #575757;
          .mod_help_title {
            text-align: center;
            font-size: 16px;
            color: #fff;
            margin-bottom: 22px;
          }
          ul {
            li {
              text-align: center;
              margin-bottom: 15px;
              font-size: 14px;
              a {
                color: #bbbbbb;
              }
            }
          }
        }
        .help_last {
          border: none;
        }
        .mod_cover {
          float: right;
          margin-right: 60px;
          text-align: center;
          img {
          }
          p {
            margin: 10px 0;
            color: #bbb;
            font-size: 14px;
          }
          h3 {
            color: #a77c5a;
            font-size: 24px;
          }
        }
      }
    }
    .f_copy {
      margin-top: 40px;
      text-align: center;
      color: #999;
    }
  }
}
.qrcode {
  width: 90px;
  height: 90px;
}
</style>
